import React from 'react'
import Image from 'next/image'
import CloudBadge from '@components/subscription/CloudBadge'
import type { ImageField, NumberField, RichTextField } from '@prismicio/client'
import { PrismicRichText } from '@prismicio/react'

interface FeaturedProductCardProps {
	product: {
		image: ImageField<never>
		name: RichTextField
	}
	value?: NumberField
	className?: string
}

export default function FeaturedProductCard({
	product,
	value,
	className = ''
}: FeaturedProductCardProps) {
	return (
		<div className={`flex flex-col w-full items-center ${className}`}>
			<div className="text-2xl md:hidden font-normal text-center pb-6">
				<PrismicRichText field={product.name} />
			</div>
			<div className="relative w-full h-full flex flex-col items-center">
				<div className="relative w-full aspect-square bg-gray-50">
					<Image
						src={product.image.url || ''}
						alt={product.image.alt || (product.name[0] as any)?.text || ''}
						fill
						className="object-contain"
					/>
				</div>
				{value && (
					<div className="absolute -top-4 -right-4 z-10">
						<CloudBadge badgeText="" badgeValue={value} />
					</div>
				)}
			</div>
			<div className="hidden md:block md:text-left w-full pt-8">
				<p className="text-lg font-bold">Featured</p>
				<div className="text-xl font-normal">
					<PrismicRichText field={product.name} />
				</div>
			</div>
		</div>
	)
}
